import axios from "axios";
import Config from "@/config"

export default class EventHubListenerService {
  getDeviceTwin(accesstoken, serialNumber/*, type*/) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/get_devicetwin_"+type+".json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("event") + "/"+serialNumber+"/device-twin?properties=info,status,versions,parameters",
        options
      )
      .then(res => res.data);
  }
  postDeviceTwin(accesstoken, serialNumber, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("event") + "/"+serialNumber+"/device-twin", data,
        options
      )
      .then(res => res.data);
  }
  postSetSetpoint(accesstoken, serialNumber, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("event") + "/"+serialNumber+"/set-setpoint", data,
        options
      )
      .then(res => res.data);
  }
  postSetParameter(accesstoken, serialNumber, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("event") + "/"+serialNumber+"/set-parameter", data,
        options
      )
      .then(res => res.data);
  }
  getHaccpReports(accesstoken, serialNumber, startTimestamp) {
    // if(Config.mock) {
    //   return axios
    //     .get(
    //       "stubs/get_haccp_reports.json?t="+new Date().getTime(),
    //     )
    //     .then(res => res.data);
    // }
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("event") + "/haccp-reports?serialNumber="+serialNumber+"&startTimestamp="+startTimestamp,
        options
      )
      .then(res => res.data);
  }
  downloadHaccpReport(accesstoken, reportId, type) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
      .get(
        Config.proxy + Config.url("event") + "/haccp-reports/" + reportId + "?type=" + type,
        options
      )
      .then(res => res);
  }
  postRunLive(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("event") + "/"+serialNumber+"/run-live", {},
        options
      )
      .then(res => res.data);
  }
  postResetOpenDoorCounter(accesstoken, serialNumber, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("event") + "/"+serialNumber+"/reset-open-doors-counter", data,
        options
      )
      .then(res => res.data);
  }
  postSetOperationalStatus(accesstoken, serialNumber, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("event") + "/"+serialNumber+"/set-operational-status", data,
        options
      )
      .then(res => res.data);
  }
  postStartStop(accesstoken, serialNumber, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("event") + "/"+serialNumber+"/start-stop", data,
        options
      )
      .then(res => res.data);
  }
}
